var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from "../hooks/useTheme";
import { LibIcon } from './components';
var Warning = function (_a) {
    var _b = _a.triangleColor, triangleColor = _b === void 0 ? 'warning500' : _b, _c = _a.exclamationColor, exclamationColor = _c === void 0 ? 'primary500' : _c, _d = _a.size, size = _d === void 0 ? 30 : _d, _e = _a.title, title = _e === void 0 ? '' : _e, props = __rest(_a, ["triangleColor", "exclamationColor", "size", "title"]);
    var theme = useTheme();
    return (React.createElement("svg", __assign({ width: size, height: size, viewBox: "0 0 27 24" }, props),
        title && React.createElement("title", null, title),
        React.createElement("g", { id: "warning-icon", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "Group-23", transform: "translate(-0.744509, -1.026136)" },
                React.createElement("path", { d: "M1.76591746,23.0175608 L24.7248016,23.0175608 C25.2888149,23.0175608 25.7460381,22.5603376 25.7460381,21.9963243 C25.7460381,21.8175548 25.6991107,21.6419173 25.6099474,21.4869708 L14.1305053,1.53819136 C13.8491972,1.04933882 13.2248586,0.881090863 12.736006,1.16239902 C12.5797722,1.2523031 12.4501178,1.38195757 12.3602137,1.53819136 L0.880771647,21.4869708 C0.599463492,21.9758233 0.767711454,22.6001619 1.25656399,22.8814701 C1.41151047,22.9706334 1.58714803,23.0175608 1.76591746,23.0175608 Z", id: "Path", fill: theme.colors[triangleColor], fillRule: "nonzero" }),
                React.createElement("rect", { id: "Rectangle", fill: theme.colors[exclamationColor], x: "12.0452752", y: "8.66756079", width: "2.41", height: "6.28" }),
                React.createElement("rect", { id: "Rectangle-Copy", fill: theme.colors[exclamationColor], x: "12.0452752", y: "16.9575608", width: "2.41", height: "2.41" })))));
};
export var WarningIcon = function (_a) {
    var exclamationColor = _a.exclamationColor, triangleColor = _a.triangleColor, size = _a.size, title = _a.title, _b = _a.iconAriaHidden, iconAriaHidden = _b === void 0 ? true : _b, wrapperLss = _a.wrapperLss;
    return (React.createElement(LibIcon, { icon: function () { return (React.createElement(Warning, { exclamationColor: exclamationColor, triangleColor: triangleColor, size: size, title: title, "aria-hidden": iconAriaHidden })); }, wrapperLss: wrapperLss }));
};
//# sourceMappingURL=WarningIcon.js.map